import React, { useState, useEffect } from "react"
import { Card, CardContent } from "../../../components/ui/card"
import { listOrgOrders } from "../../../utils/orderHelpers"
import CustomerOverviewSection from "./CustomerOverviewSection"

const formatCurrency = (value) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value || 0)

const CommerceCustomersPanel = ({ organization }) => {
  const orgId = organization?.orgId
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    setLoading(true)
    listOrgOrders(orgId).then(({ orders }) => {
      const byEmail = {}
      orders?.forEach((o) => {
        if (!o?.customerEmail) return
        if (!byEmail[o.customerEmail]) {
          byEmail[o.customerEmail] = { email: o.customerEmail, name: o.customerName || "—", type: o.customerType || "individual", orderCount: 0, totalSpent: 0 }
        }
        if (o.status === "paid") {
          byEmail[o.customerEmail].orderCount += 1
          byEmail[o.customerEmail].totalSpent += o.amount || 0
        }
      })
      setCustomers(Object.values(byEmail).sort((a, b) => b.totalSpent - a.totalSpent))
      setLoading(false)
    })
  }, [orgId])

  if (loading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 6 })?.map((_, i) => <div key={i} className="h-12 rounded-lg bg-muted animate-pulse" />)}
      </div>
    )
  }

  if (!customers?.length) {
    return (
      <Card className="shadow-none">
        <CardContent className="p-8 text-center text-muted-foreground">No customers yet. Anyone who completes a purchase will show up here.</CardContent>
      </Card>
    )
  }

    return (
    <div>
      <CustomerOverviewSection orgId={orgId} dateRange="30d" showReportLink={false} />
      <Card className="shadow-none">
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-muted-foreground">
              <th className="p-3 font-medium">Customer</th>
              <th className="p-3 font-medium">Type</th>
              <th className="p-3 font-medium">Orders</th>
              <th className="p-3 font-medium">Total Spent</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.email} className="border-b border-border last:border-0 hover:bg-muted/40">
                <td className="p-3">
                  <div className="font-medium text-foreground">{c.name}</div>
                  <div className="text-xs text-muted-foreground">{c.email}</div>
                </td>
                <td className="p-3 capitalize text-muted-foreground">{c.type}</td>
                <td className="p-3">{c.orderCount}</td>
                <td className="p-3 font-medium">{formatCurrency(c.totalSpent)}</td>
              </tr>
            ))}
          </tbody>
                </table>
      </CardContent>
      </Card>
    </div>
  )
}

export default CommerceCustomersPanel